import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsTabBarComponent } from "./ds-tab-bar.component";

@NgModule({
  declarations: [DsTabBarComponent],
  imports: [CommonModule],
  exports: [DsTabBarComponent],
})
export class DsTabBarModule {}
